import React, { Component } from 'react'
import { withRouter } from "react-router";
import { FormattedMessage, injectIntl, FormattedRelative, FormattedNumber } from 'react-intl'
import $ from 'jquery'
import ShopifyAppContext from '../shopify/shopifyappcontext.js'
import GlobalHelper from '../common/GlobalHelper.jsx';
import ProgressBar from "../common/progress-bar/progressbar.component.jsx";

class LoadingComponent extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            loadingMessage: this.props.loading,
            progress: 0,
            message: ""
        }
        this.updateProgress = this.updateProgress.bind(this)
        this.startLoading = this.startLoading.bind(this)
    }

    componentDidMount() {
        $("#loadingModal").modal('show');
        this.setState({
            message: <FormattedMessage
                id="loading.subscription.chargebee_account_loading"
                defaultMessage="Loading..."
            />
        }, () => this.startLoading())
    }

    startLoading() {
        window.scrollTo(0, 0)
        this.interval = setInterval(this.updateProgress, 300)
    }

    updateProgress() {
        if (this.state.progress < 100) {
            let message = <FormattedMessage
                id="loading.subscription.chargebee_account"
                defaultMessage="Setting up your account..."
            />
            if (this.state.progress > 30) {
                message = <FormattedMessage
                    id="loading.subscription.chargebee_preferences"
                    defaultMessage="Setting up your subscription preferences..."
                />
            }
            if (this.state.progress > 50) {
                message = <FormattedMessage
                    id="loading.subscription.chargebee_plan"
                    defaultMessage="Setting up your plan attributes..."
                />
            }
            if (this.state.progress > 70) {
                message = <FormattedMessage
                    id="loading.subscription.chargebee_billing_information"
                    defaultMessage="Setting up your Billing Information..."
                />
            }
            if (this.state.progress > 90) {
                message = <FormattedMessage
                    id="loading.subscription.chargebee_final_configurations"
                    defaultMessage="Final Configurations..."
                />

            }
            this.setState({
                progress: this.state.progress + 2,
                message: message,
            })

        } else {
            clearInterval(this.interval)
            if (GlobalHelper.getShopifyIntegrationOrigin()) {
                ShopifyAppContext.redirectTo('/my-account')
            } else {
                this.props.history.push("/my-account");
                window.location.reload(false)
            }
        }
    }

    render() {
        return (
            <div className="modal" id="loadingModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" style={{ width: "100%", height: "100%" }} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={'mt-8'}>
                                <span className={'mb-1 text-center'}>
                                    <strong>{this.state.message}</strong>
                                </span>
                                <ProgressBar progress={this.state.progress} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        )
    }
}

export default withRouter(LoadingComponent)


// WEBPACK FOOTER //
// ./src/my-account/loading.component.jsx